/**
 * One-time launch pop-ups (backend account.launch_popups). The server decides
 * who a pop-up is for and remembers that it was shown, across devices.
 */
import api from "../api";

export type LaunchPopupKey = "vendors";

/** Whether launch pop-up `key` is due for the signed-in member. */
export async function getLaunchPopup(key: LaunchPopupKey) {
  const response = await api.get(`/api/account/launch-popup/${key}/`);
  return response.data as { show: boolean };
}

/** Record that pop-up `key` was shown (or its feature found first), so it never shows again. */
export async function markLaunchPopupSeen(key: LaunchPopupKey) {
  await api.post(`/api/account/launch-popup/${key}/`);
}
